import React from 'react';
import { InputNumber } from 'antd';
import type { FJ750 } from '../../../services/pwj220Api';
import LookupField from '../../../components/LookupField';

interface Props {
  formData: Partial<FJ750>;
  isEditing: boolean;
  onChange: (field: keyof FJ750, value: any) => void;
}

const BONDING_METHODS: Record<number, string> = {
  1: '無膜一般膠貼合',
  2: '無膜濕式聚氨酯貼合',
  3: '有膜熱熔膠貼合',
  4: '有膜聚氨酯貼合',
  5: '其他',
};

const Tab3CostInfo: React.FC<Props> = React.memo(({ formData, isEditing, onChange }) => {
  const val = (f: keyof FJ750) => (formData[f] ?? '') as string;
  const numVal = (f: keyof FJ750) => (formData[f] ?? 0) as number;

  return (
    <div className="form-grid">
      {/* 貼合方式 (fj750_45, Page3) */}
      <h4 className="section-title">貼合方式</h4>
      <div />

      <label>貼合方式</label>
      <div className="inline-group">
        <select
          data-contract-field="fj750_45"
          value={numVal('fj750_45')}
          onChange={e => onChange('fj750_45', parseInt(e.target.value))}
          disabled={!isEditing}
          className="form-select"
        >
          {Object.entries(BONDING_METHODS).map(([k, v]) => (
            <option key={k} value={k}>{v}</option>
          ))}
        </select>
        {numVal('fj750_45') === 5 && (
          <input
            value={val('fj750_453')}
            onChange={e => onChange('fj750_453', e.target.value)}
            disabled={!isEditing}
            className="form-input"
            placeholder="其他說明"
          />
        )}
      </div>

      {/* 加工廠 (fj750_46, Page3 - hasDblClick → LookupField) */}
      <label>加工廠</label>
      <LookupField
        lookupType="supplier"
        value={val('fj750_46')}
        onChange={(code) => onChange('fj750_46', code)}
        disabled={!isEditing}
        title="選擇加工廠"
      />

      {/* 貼合工繳 (fj750_471 + fj750_472, Page3) */}
      <label>貼合工繳(NTD)</label>
      <div className="inline-group">
        <InputNumber
          value={numVal('fj750_471')}
          onChange={v => onChange('fj750_471', v || 0)}
          disabled={!isEditing}
          className="form-input"
        />
        <input
          value={val('fj750_472')}
          maxLength={3}
          onChange={e => onChange('fj750_472', e.target.value)}
          disabled={!isEditing}
          className="form-input narrow"
          placeholder="大貨"
        />
      </div>

      {/* 試樣 (fj750_481 + fj750_482, Page3) */}
      <label>試樣</label>
      <div className="inline-group">
        <InputNumber
          value={numVal('fj750_481')}
          onChange={v => onChange('fj750_481', v || 0)}
          disabled={!isEditing}
          className="form-input"
        />
        <input
          value={val('fj750_482')}
          maxLength={3}
          onChange={e => onChange('fj750_482', e.target.value)}
          disabled={!isEditing}
          className="form-input narrow"
          placeholder="單位"
        />
      </div>

      {/* 成品布-成本 (fj750_491 + fj750_492, Page3 - fj750_492 hasDblClick → LookupField) */}
      <label>成品布-成本(NTD)</label>
      <div className="inline-group">
        <InputNumber
          value={numVal('fj750_491')}
          onChange={v => onChange('fj750_491', v || 0)}
          disabled={!isEditing}
          className="form-input"
        />
        <LookupField
          lookupType="measureUnit"
          value={val('fj750_492')}
          onChange={(code) => onChange('fj750_492', code)}
          disabled={!isEditing}
          title="選擇單位"
          style={{ width: 100 }}
        />
      </div>

      {/* 供應商 (fj750_50, Page3 - hasDblClick → LookupField) */}
      <label>供應商</label>
      <LookupField
        lookupType="supplier"
        value={val('fj750_50')}
        onChange={(code) => onChange('fj750_50', code)}
        disabled={!isEditing}
        title="選擇供應商"
      />

      {/* 工廠布號 (fj750_501, Page3) */}
      <label>工廠布號</label>
      <input
        data-contract-field="fj750_501"
        value={val('fj750_501')}
        maxLength={15}
        onChange={e => onChange('fj750_501', e.target.value)}
        disabled={!isEditing}
        className="form-input"
      />

      {/* 物化性報告 */}
      <h4 className="section-title">物化性報告</h4>
      <div />

      <label>物化性報告單號1</label>
      <LookupField
        lookupType="sampleAnalysis"
        contractFieldId="fj750_61"
        value={val('fj750_61')}
        onChange={(code) => onChange('fj750_61', code)}
        disabled={!isEditing}
        title="選擇物化性報告單號"
      />

      <label>物化性報告單號2</label>
      <LookupField
        lookupType="sampleAnalysis"
        contractFieldId="fj750_611"
        value={val('fj750_611')}
        onChange={(code) => onChange('fj750_611', code)}
        disabled={!isEditing}
        title="選擇物化性報告單號"
      />

      <label>物化性報告單號3</label>
      <LookupField
        lookupType="sampleAnalysis"
        contractFieldId="fj750_612"
        value={val('fj750_612')}
        onChange={(code) => onChange('fj750_612', code)}
        disabled={!isEditing}
        title="選擇物化性報告單號"
      />
    </div>
  );
});

export default Tab3CostInfo;
